import { DoorIcon } from '@fronton/icons-react';
import { DesignRegistrationPanelStructure } from 'common/components/design-registration-panel';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';

export const INTERIOR_DOORS_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: DoorIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на консультацию и\u00A0замер',
    },
    actionBlock: [],
  },
  mobilePanel: {
    mobileButton: {
      label: 'Записаться на консультацию',
      elementBlock: INTERIOR_DOORS_ELEMENT_BLOCK,
    },
    content: {
      icon: DoorIcon,
      iconColor: 'text-invert',
      iconType: 'duotone',
      text: 'Запишитесь на консультацию и\u00A0замер',
    },
    actionBlock: [],
  },
};
